import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

export default function DraggableWrapper({
  isDragDisabled,
  draggableId,
  index,
  type,
  isDisabled,
  children,
}) {
  if (isDragDisabled) {
    // Call children with empty props when drag is disabled
    return children({
      draggableProps: {},
      dragHandleProps: {},
      innerRef: () => {},
    });
  }

  return (
    <Draggable
      draggableId={draggableId}
      index={index}
      type={type}
      isDragDisabled={isDisabled}
    >
      {children}
    </Draggable>
  );
}

DraggableWrapper.propTypes = {
  isDragDisabled: PropTypes.bool,
  draggableId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  children: PropTypes.func.isRequired,
};

DraggableWrapper.defaultProps = {
  isDragDisabled: false,
  isDisabled: false,
};

